
export default class VideoWrapper extends HTMLDivElement {

    constructor() {
        super();
    }

    mutationConfig = { attributes: false, childList: true, subtree: true };

    connectedCallback() {

        const videoWrapper = this;

        // Callback function to execute when mutations are observed
        const callback = (mutationList, observer) => {
            for (const mutation of mutationList) {
                mutation.addedNodes.forEach(function (node) {
                    if (node.nodeName.toLowerCase() === "video") {
                        const autoplay = node.getAttribute('playsinline') != null || node.getAttribute('autoplay') != null;
                        const controls = node.getAttribute('controls') != null;

                        if (autoplay && !controls) {
                            let btn = document.createElement("button");
                            btn.className = "btn btn-clean jumbotron-background-video-pause";
                            btn.innerHTML = `
                            <svg class="icon-play d-none icon"><use xlink:href="/Static/images/icons/icons.svg#icon-play"></use></svg>
                            <svg class="icon-pause icon"><use xlink:href="/Static/images/icons/icons.svg#icon-pause"></use></svg>
                            `;
                            btn.setAttribute("aria-label", "pausa video");
                            btn.addEventListener("click", videoWrapper.togglePlay);
                            videoWrapper.querySelector(".background-video").appendChild(btn);
                        }

                        observer.disconnect();
                    }

                });
            }
        };

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(this, this.mutationConfig);
    }

    disconnectedCallback() {

    }

    togglePlay = () => {

        if (this.videoElement.paused) {
            this.toggleButton.querySelector(".icon-pause").classList.remove("d-none");
            this.toggleButton.querySelector(".icon-play").classList.add("d-none");
            this.videoElement.play();
            this.toggleButton.setAttribute("aria-label", "Stoppa video");
        }
        else {
            this.toggleButton.querySelector(".icon-pause").classList.add("d-none");
            this.toggleButton.querySelector(".icon-play").classList.remove("d-none");
            this.videoElement.pause();
            this.toggleButton.setAttribute("aria-label", "Starta video");
        }

    }

    get toggleButton() {
        return this.querySelector(".jumbotron-background-video-pause");
    }

    get videoElement() {
        return this.querySelector("video");
    }


}

customElements.define('video-wrapper', VideoWrapper, { extends: "div" });